import { action } from '@play-co/replicant';
import createActions from 'src/replicant/actions/utils/createActions';
import { duration } from '../utils/duration';

export default createActions({
  /** Replicant heartbeat action, used to detect when the session has ended */
  heartbeat: action((state, _: void, api) => {
    state.isOnline = true;

    api.scheduledActions.unschedule('sendStatusChangedChatbotMessage');
    api.scheduledActions.schedule.triggerOnGameEnd({
      args: null,
      notificationId: 'triggerOnGameEnd',
      delayInMS: duration({ minutes: 1 }),
    });
  }),
});
